<template>
  <div class="heroes-list-category" :class="classes">
    <button class="heroes-list-category__btn" @click="$emit('click', $event)">
      <img
        :src="category.img"
        :alt="category.name"
        class="heroes-list-category__img"
      />
      <span class="heroes-list-category__name">{{ category.name }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "HeroesListCategory",
  props: {
    category: {
      typew: Object,
      required: true
    },
    checked: Boolean
  },
  computed: {
    classes() {
      return {
        "is-checked": this.checked
      };
    }
  }
};
</script>

<style lang="scss">
$p: ".heroes-list-category";

.heroes-list-category {
  font-size: 15px;
  color: #3cacdd;
  font-family: "Montserrat";
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  width: 33.33333%;
  height: 70px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  cursor: pointer;
  margin-bottom: -10px;
  padding-bottom: 10px;

  &:hover {
    background: rgba(#0f1a39, 0.5);
  }

  &:focus-within {
    position: relative;
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 60px;
  }

  &__img {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    margin-right: 8px;
  }

  &.is-checked {
    background: #0f1a39;
    #{$p}__btn {
      color: #fff;
    }
  }

  @include breakpoint("xs-only") {
    &__img {
      margin-right: 0;
    }
    &__name {
      display: none;
    }
  }
}
</style>
